import { values } from './enums'

const _enum = {
  Editable: 0,
  Locked: 1
}

export const OutputReportGroupState = {
  enumName: 'OutputReportGroupState',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/outputReportGroupState.js